import React, { useState } from 'react';
import Pagination from '../../../Elements/Pagination';

function PaginationDemoComponent() {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const totalCount = 137;
  return (
    <div>
      <Pagination
        pageNumber={pageNumber}
        numberOfElementsInTheTable={totalCount}
        numberOfElementsOnThePage={pageSize}
        onClick={(newPage) => setPageNumber(newPage)}
        onChangeOfRangeSelector={(newSize) => {
          setPageSize(Number(newSize));
          setPageNumber(1);
        }}
        rangeMax={500}
        itemTypeName='demo items'
      />
      <p style={{ fontSize: 13, color: 'var(--ink-2)' }}>
        State: page {pageNumber}, {pageSize} per page, {totalCount} total (dummy).
      </p>
    </div>
  );
}

export const paginationDemo = {
  id: 'pagination',
  title: 'Pagination',
  category: 'Lists & Grids',
  importPath: 'Elements/Pagination',
  notes: [
    'Fully controlled: pageNumber + numberOfElementsInTheTable + numberOfElementsOnThePage in, onClick(page) out.',
    'Pass onChangeOfRangeSelector={null} to hide the rows-per-page selector.',
    'Usually rendered by TabOfDataTable — only use directly on custom lists.',
  ],
  snippet:
    "<Pagination\n  pageNumber={pageNumber}\n  numberOfElementsInTheTable={totalCount}\n  numberOfElementsOnThePage={pageSize}\n  onClick={(p) => setPageNumber(p)}\n  onChangeOfRangeSelector={(size) => setPageSize(Number(size))}\n  rangeMax={500}\n  itemTypeName='items'\n/>",
  render: PaginationDemoComponent,
};
